import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { SubscriptionOrderFinal } from 'entities/tariff/api/contracts';
import SuccessIcon from 'entities/tariff/ui/SuccessIcon/SuccessIcon.svg?react';
import { OrderSummaryTextStyled } from 'features/tariffs/subscribe/ui/SubscribeModals/SubscribeComplete/SubscribeComplete.styles';
import { ModalDropdown } from 'shared/ui/ModalDropdown/ModalDropdown';
import {
	OrderSummaryContainerStyled,
	OrderSummaryHeaderContainerStyled,
	OrderSummaryHeadingStyled,
} from './EditComplete.styles';

interface Props {
	subscription: SubscriptionOrderFinal | undefined;
}
export const EditComplete: FC<Props> = ({ subscription }) => {
	const { t } = useTranslation();

	if (!subscription) {
		return null;
	}

	return (
		<OrderSummaryContainerStyled>
			<OrderSummaryHeaderContainerStyled>
				<SuccessIcon />
				<OrderSummaryHeadingStyled>{t(`Marketplace_Subscription_Edited`)}</OrderSummaryHeadingStyled>
			</OrderSummaryHeaderContainerStyled>

			<ModalDropdown
				header={t(`Marketplace_Invoice_Coming_Date`, {
					date: subscription.invoiceDate
						? dayjs(subscription.invoiceDate).format(`DD.MM.YYYY`)
						: t(`Marketplace_First_Day_Of_The_Month`),
				})}
				content={
					<OrderSummaryTextStyled>{t(`Marketplace_Active_Subscription_Details`)}</OrderSummaryTextStyled>
				}
			/>
		</OrderSummaryContainerStyled>
	);
};
